<div>
    <div
            aria-labelledby="home-tab"
            class="tab-pane fade show active"
            id="home"
            role="tabpanel"
    >
        <div class="container-fluid">
            <div class="content-block">
                <div class="form-modified">
                    <div class="error-list m-0" v-if="ui.error.error_message">
                        <ul class="error-msg">
                            <li :key="x" v-for="(error,x) in ui.error.error_message">
                                <div :key="i" v-for="(err,i) in error">
                                    <p> {{err}}</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="row">
                        <div class="col-lg-2 pr-0">
                            <div class="inner-v-sidebar">
                                <ul class="nav flex-column" id="myTab" role="tablist">
                                    <li
                                            :key="index"
                                            class="nav-item"
                                            v-for="(content, index) in item.tab"
                                    >
                                        <a
                                                :class="index === ui.index.selected ? 'active' : '' "
                                                @click.prevent="selectedTabContent(content, index)"
                                                aria-controls="home"
                                                aria-selected="true"
                                                class="nav-link"
                                                data-toggle="tab"
                                                href="#home"
                                                id="home-tab"
                                                role="tab"
                                        >{{ content.title }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-10 pl-0">
                            <div class="tab-content bg-white p-3" id="myTabContent">
                                <div
                                        aria-labelledby="home-tab"
                                        class="tab-pane fade show active"
                                        id="home"
                                        role="tabpanel"
                                >
                                    <div class="form-group">
                                        <label class="col-form-label" for="staticEmail"> Description</label>
                                        <label class="readonly w-100" v-if="!ui.status.editContent && ui.index.edited === item.contentData.index ">{{
                                            item.contentData.description
                                            }}</label>
                                        <label class="readonly w-100" v-if="ui.index.edited !== item.contentData.index ">{{
                                            item.contentData.description
                                            }}</label>
                                        <div v-if="ui.status.editContent && ui.index.edited === item.contentData.index ">
                      <textarea
                              class=""
                              id=""
                              name=""
                              placeholder="eg. Description"
                              v-model="item.contentData.description"
                      ></textarea>
                                        </div>
                                    </div>
                                    <button
                                            @click.prevent="onEditSelectedContentClick"
                                            class="btn default-btn"
                                            type="submit"
                                            v-if="!ui.status.editContent"
                                    >
                                        Edit
                                    </button>
                                    <button
                                            :disabled="ui.status.postLoading.saveAboutContent"
                                            @click.prevent="saveSelectedContent"
                                            class="btn default-btn save-btn"
                                            type="submit"
                                            v-if="ui.status.editContent && ui.index.edited === item.contentData.index"
                                    >
                                        Save
                                        <spinner :loading="ui.status.postLoading.saveAboutContent" v-if="ui.status.postLoading.saveAboutContent"></spinner>
                                    </button>
                                    <button
                                            :disabled="ui.status.postLoading.saveAboutContent"
                                            @click.prevent="onCancelSelectedContentClick"
                                            class="btn default-btn cancel"
                                            type="submit"
                                            v-if="ui.status.editContent && ui.index.edited === item.contentData.index"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
